import { CommonModule, isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, Inject, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'usersnap',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './usersnap.component.html',
  styleUrl: './usersnap.component.css',
})
export class UsersnapComponent implements AfterViewInit {
  showUsersnapWidget = false;
  widgetReady = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      const hidden = localStorage.getItem('usersnapWidgetHidden');
      if (hidden === 'false' || hidden === null) {
        // check if the there is any key start with "us-visitorEmail" in localStorage
        const hasVisitorEmail = Object.keys(localStorage).some((key) =>
          key.startsWith('us-visitorEmail')
        );
        if (hasVisitorEmail) {
          localStorage.setItem('usersnapWidgetHidden', 'true');
          this.showUsersnapWidget = false;
        } else {
          localStorage.setItem('usersnapWidgetHidden', 'false');
          this.showUsersnapWidget = true;
        }
      }
    }
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId) && this.showUsersnapWidget) {
      (window as any).onUsersnapLoad = (api: any) => {
        setTimeout(() => {
          const mountNode = document.getElementById('widgetContainer');
          if (mountNode) {
            api.init({ mountNode });
            this.widgetReady = true;
          }
        }, 0); // Đợi DOM render xong
      };
      if (!document.getElementById('usersnap-script')) {
        const script = document.createElement('script');
        script.id = 'usersnap-script';
        script.defer = true;
        script.src =
          'https://widget.usersnap.com/embed/load/e7c25c46-0630-4001-b913-3052071e1b80?onload=onUsersnapLoad';
        document.head.appendChild(script);
      } else {
        if ((window as any).Usersnap) {
          (window as any).onUsersnapLoad((window as any).Usersnap);
        }
      }
    }
  }

  closeUsersnapWidget(): void {
    this.showUsersnapWidget = false;
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('usersnapWidgetHidden', 'true');
    }
  }
}
